import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class DownloadService {


    constructor() { }

    download(body, filename){
        // { type: 'text/csv;charset=utf-8;' }
        // "application/octet-stream"
        const blob: any = new Blob([body], {type: "octet-stream"});
        let url = URL.createObjectURL(blob);
        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  
          dwldLink.setAttribute("target", "_blank");
        }
        if (dwldLink.download !== undefined) {
          dwldLink.setAttribute("href", url);
          dwldLink.setAttribute("download", filename);
          dwldLink.style.visibility = "hidden";
          document.body.appendChild(dwldLink);
          dwldLink.click();
          document.body.removeChild(dwldLink);
        }
      }
}